const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5007';

export const API_ENDPOINTS = {
  empleados: `${API_BASE_URL}/api/empleados`,
  periodos: `${API_BASE_URL}/api/periodos`,
  balances: `${API_BASE_URL}/api/balances`,
  departamentos: `${API_BASE_URL}/api/departamentos`,
  tiposLicencia: `${API_BASE_URL}/api/tipos-licencia`,

  // Auth
  login: `${API_BASE_URL}/api/auth/login`,
  register: `${API_BASE_URL}/api/auth/register`,
  registrarEmpresa: `${API_BASE_URL}/api/auth/registrar-empresa`,
  refreshToken: `${API_BASE_URL}/api/auth/refresh-token`,
  revokeToken: `${API_BASE_URL}/api/auth/revoke-token`,
  me: `${API_BASE_URL}/api/auth/me`,
  importarPeriodos: `${API_BASE_URL}/api/periodos/importar`,
};

export default API_BASE_URL;
